import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from './baseQuery';

export const patientDetailsAPI = createApi({
  baseQuery: tsdaBaseQuery,
  reducerPath: 'patientDetailsAPI',
  endpoints: builder => ({
    getAllPatientDetails: builder.mutation<any, any>({
      query: ({
        search_scope,
        study_id,
        country,
        site_id,
        application,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(endPoints.PatientDetailsAPI.getAll)}?search_scope=${search_scope}${
          study_id !== null ? `&study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    getPatientId: builder.mutation<any, any>({
      query: ({
        patient_id,
        study_id,
        country,
        site_id,
        application,
        application_section,
        application_module_section,
        search_scope
      }) => ({
        url: `${formatString(endPoints.PatientDetailsAPI.patientIdentifierSelect, {
          key: urlKeys.patient_id,
          value: patient_id
        })}?search_scope=${search_scope}&study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    getPrescreenId: builder.mutation<any, any>({
      query: ({
        prescreen_id,
        study_id,
        country,
        site_id,
        application,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(endPoints.PatientDetailsAPI.prescreeningIdSelect, {
          key: urlKeys.prescreen_id,
          value: encodeURIComponent(prescreen_id)
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    getSubjectID: builder.mutation<any, any>({
      query: ({
        subject_id,
        study_id,
        country,
        site_id,
        application,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(endPoints.PatientDetailsAPI.subjectIDSelect, {
          key: urlKeys.subject_id,
          value: encodeURIComponent(subject_id)
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    applyFilterGetAllAuditTSDA: builder.mutation<any, any>({
      query: ({
        audit_module_section,
        id,
        site_id,
        study_id,
        country,
        application,
        isOnlyUpdate,
        startFrom,
        maxSize,
        sortbyColumn,
        sortOrder,
        data,
        application_section
      }) => ({
        url: `${formatString(
          endPoints.Audit.applyFilterGetAll,
          { key: urlKeys.audit_module_section, value: audit_module_section },
          { key: urlKeys.id, value: id }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&only_update=${isOnlyUpdate}&from=${startFrom}&size=${maxSize}&sort_by=${sortbyColumn}&sort_order=${sortOrder}&application_section=${application_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getUnscheduledVisitCrfs: builder.mutation<any, any>({
      query: ({ study_id, country, site_id, application }) => ({
        url: `${formatString(endPoints.monitoringEvent.unscheduledvisitCrf, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id)
        })}?country=${country}&site_id=${site_id}&application=${application}`,
        method: 'GET'
      })
    }),
    createUnschedulesVisitEvent: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id, application }) => ({
        url: `${formatString(endPoints.monitoringEvent.unScheduledVisitCreate, {
          key: urlKeys.study_id,
          value: study_id
        })}?country=${country}&site_id=${site_id}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useGetAllPatientDetailsMutation,
  useGetPatientIdMutation,
  useGetPrescreenIdMutation,
  useGetSubjectIDMutation,
  useApplyFilterGetAllAuditTSDAMutation,
  useGetUnscheduledVisitCrfsMutation,
  useCreateUnschedulesVisitEventMutation
} = patientDetailsAPI;
